/* 쿠키를 설정 합니다.
 document.cookie = `accessToken=${response.data.token.accessToken}`;
 */
export const setCookie = (name: string, value: string, days: number): void => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 1000 * 60));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

// 쿠키를 불러 옵니다.
export const getCookie = (name: string): string => {
  const value = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return value ? value[2] : '';
};

// 쿠키를 제거 합니다.
export const delCookie = (name: string): void => {
  const date = new Date();
  date.setDate(date.getDate() - 100);
  const cookie = `${name}=;Expires=${date.toUTCString()}`;
  document.cookie = cookie;
};

export default {
  setCookie,
  getCookie,
  delCookie,
};
